const styles = {
  menu: {
    margin: '0px 0px',

    paddingLeft: '0px',
    textAlign: 'left',
    borderRadius: '0px',
    width: '100%',
    backgroundColor: '#ffffff',
    borderWidth: '0px',
    color: 'ffffff',
    verticalAlign: 'middle',
  },

  menuItem: {
    padding: '12px 0px 12px 20px',
    fontFamily: 'FuturaTodayDemibold',
    height: '38px',
    letterSpacing: '0.4px',
    textAlign: 'left',
    color: '#333333',
    fontSize: '12px',
    verticalAlign: 'middle',
    width: '100%',
    lineHeight: 1.1,
  },

  accordian: {
    margin: '0px 0px',
    paddingLeft: '0px',
    textAlign: 'left',
    borderRadius: '0px',
    borderWidth: '0px',
    color: 'ffffff',
    verticalAlign: 'middle',
    backgroundColor: '#333333',
  },

  accordianTitle: {
    height: '38px',
    letterSpacing: '0.4px',
    textAlign: 'left',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
    fontFamily: 'FuturaTodayNormal',
    fontSize: '13px',
    borderTop: 'solid 1px rgba(255, 255, 255, 0.1)',
    padding: '0px 0px 0px 18px',
    lineHeight: 1.4,
    // verticalAlign: 'middle',
    display: 'flex',
  },

  teamsDivisionName: {
    padding: '11px 0px 11px 20px',
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    height: '38px',
    letterSpacing: '0.4px',
    textAlign: 'left',
    fontSize: '12px',
    verticalAlign: 'middle',
    width: '100%',
    fontStyle: 'oblique',
    color: '#666666',
  },

  accordianContent: {
    padding: '0px 0px',
  },

  angleDown: {
    color: '#dd9933',
    fontWeight: 600,
  },

  emptyAccordianContent: {
    padding: '0px',
  },

  link: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    // display: 'block',
    padding: '12px 15px 12px 20px',
    fontFamily: 'FuturaTodayDemibold',
    height: '38px',
    letterSpacing: '0.4px',
    textAlign: 'left',
    color: 'inherit',
    fontSize: '12px',
    verticalAlign: 'middle',
    width: '100%',
    lineHeight: 1.1,
  },

  titleContainer: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
    color: 'inherit',
    alignItems: 'center',
  },

  titleLink: {
    display: 'flex',
    height: '100%',
    width: '100%',
    color: 'inherit',
    alignItems: 'center',
  },

  accordionToggleButton: {
    display: 'inline-flex',
    width: '42px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    boxShadow: '-1px 0 0 0 rgba(255, 255, 255, 0.1)',
  },
};
export default styles;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarLowerMenu.styles.js